import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    FormsModule,
    ReactiveFormsModule,
} from '@angular/forms';
import { DirectivesModule } from '@directives/directives.module';
import { PipeModule } from '@pipes/pipe.module';

const SHARED_EXPORTS = [
    CommonModule,
    DirectivesModule,
    PipeModule,
    FormsModule,
    ReactiveFormsModule,
];
@NgModule({
    imports: [
        ...SHARED_EXPORTS,
    ],
    exports: [
        ...SHARED_EXPORTS,
    ],
})
export class ComponentSharedModule { }
